/**
 * Date formatting utilities for the application
 * Standard format: DMY (e.g., "1Feb26" for February 1, 2026)
 */

/**
 * Format a date to DMY format: "1Feb26"
 * @param date - Date object to format
 * @returns Formatted date string (e.g., "1Feb26")
 */
export function formatDateDMY(date: Date): string {
  const day = date.getDate(); // No leading zero
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear().toString().slice(-2); // Last 2 digits
  
  return `${day}${month}${year}`;
}

/**
 * Format a date for longer display with full month name
 * @param date - Date object to format
 * @returns Formatted date string (e.g., "February 1, 2026")
 */
export function formatDateLong(date: Date): string {
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
}

/**
 * Format accuracy for display. Use consistently across Manage Use Case.
 * Accepts 0-100 (e.g. 92) or 0-1 decimal (e.g. 0.92); always displays as "92%".
 */
export function formatAccuracy(accuracy: number): string {
  const value = accuracy <= 1 ? Math.round(accuracy * 100) : Math.round(accuracy);
  return `${value}%`;
}
